import React from 'react'

export default function Footer() {
    return (
        <div className="py-3 bg-black">
            <div className="text-base md:text-lg text-white text-center ">©2021 Design & Developed By <br className="block md:hidden" /> <span className="hidden md:inline-block">|</span> <a href="https://ankitraj.pages.dev/">Ankit Raj</a>  | All Rights Reserved.</div>
        </div>
    )
}
